// src/pages/OrderManage.js
import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { calculateAge, comma, dateFormatDateTime, dateFormatToISOString, useListPageFilter } from "@/utils";
import { Confirm, PageTabs, Toast, Pagination } from "@/components";

import {
    chargeMethodOptions,
    contractStatusOptions,
    chargeStatusOptions,
    orderSubStatusOption,
    orderTypeOptions,
    branchTypeOptions,
} from "@/constants/selectOptions";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";
import { useGetOrdersAdminMutation, usePutConfirmOrderAdminMutation } from "../../redux/adminOrderApi";
import {memberStatusOptions, orderMethodOptions, rolesOptions} from "../../constants/selectOptions";
import Select from "react-select";

// 페이지 기본 필터
const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        status: "",
        started_at: "",
        ended_at: "",
    },
};

export const AdminOrderManage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    // 탭(토글) 상태: "order" / "allocation"
    const [currentTab, setCurrentTab] = useState("order");

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        orderDetailPopupStatus: false,
        partnersPopupStatus: false,
        selectedOrder: {},

        // put Confirm api
        rentCorpId: "",
        orderId: "",
        triggerSearch: false,
    });

    const { confirmStatus, orderDetailPopupStatus, partnersPopupStatus, rentCorpId, orderId, triggerSearch } = formData;

    // 탭 추가 로직
    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "오더 목록" },
                });
            }
        };
        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const [getOrderLiveList, { data: listData, error: listError }] = useGetOrdersAdminMutation();
    const [putConfirmOrder] = usePutConfirmOrderAdminMutation();

    /*
    useEffect(() => {
        getOrderLiveList({ params: parameters });
    }, [parameters]);
     */



    useEffect(() => {
        console.log(listData);
    }, [listData]);

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
        getOrderLiveList({ params: parameters });

    }, []);

    useEffect(() => {
        getOrderLiveList({ params: parameters });
    }, [formData.parameters.page]);

    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
        getOrderLiveList({ params: parameters });
    };

    const showConfirm = (title, description, buttons) => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: title,
                confirmDescription: description,
                confirmButtons: buttons,
            },
        }));
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}
            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">오더 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>ERP 관리</li>
                                <li>오더 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                <span className="data-count">전체 {listData?.pagination?.totalElements ?? 0} 건</span>
                            </div>
                            <div className="table-buttons"></div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                {currentTab === "order" && (
                                    <table>
                                        <colgroup>
                                            <col width="4%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="8%" />
                                            <col width="16%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                            <col width="6%" />
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">오더번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">회원 ID</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">회원 구분</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">오더 구분</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">오더 방식</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">요청일자</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">본/지점</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">지역</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차량정보</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">고객연령</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험사</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">관리자확인</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">계약상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">청구상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">오더상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">관리</span>
                                                </div>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {listData?.data &&
                                            listData?.data?.map((item, index) => (
                                                <tr key={`liveItem${index}`}>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.serialNumber || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span
                                                                className="cell-desc">{item.orderMember?.loginId || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.orderMember?.roles
                                                                    ?.map((role) => rolesOptions.find((e) => e.value === role)?.label)
                                                                    .join(", ")}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span className="cell-tag tag-box tag-green">
                                                                    {orderTypeOptions.find((e) => e.value === item.orderType)?.label}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span className={`cell-tag tag-box  ${item.orderMethod === 'ALL' ? 'tag-error' : 'tag-blue'}`}>
                                                                    {orderMethodOptions.find((e) => e.value === item.orderMethod)?.label}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span
                                                                className="cell-desc">{dateFormatDateTime(item.createdAt)}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {item.orderMember?.firstAddressCode?.name || ""}{" "}
                                                                    {item.orderMember?.secondAddressCode?.name || ""}{" "}
                                                                    {item.orderMember?.branchType &&
                                                                        `(${
                                                                            branchTypeOptions?.find(
                                                                                (option) => option.value === item.orderMember?.branchType
                                                                            )?.label
                                                                        })`}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {item?.orderCustomer?.location2AddressCode?.address1 ?? ""}{" "}
                                                                    {item?.orderCustomer?.location2AddressCode?.address2 ?? ""}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="left">
                                                                <span
                                                                    className="cell-desc">{`(${item.carNumber ?? ""}) ${
                                                                    item.modelName ?? ""
                                                                } ${item.modelDetailName ?? ""} ${item.trimName ?? ""} ${
                                                                    item.className ?? ""
                                                                } (${comma(item.displacement) ?? "-"}cc)`}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {calculateAge(new Date(item?.orderCustomer?.birthDate) ?? new Date())}세
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span
                                                                className="cell-desc">{item?.orderInsurance?.insuranceCorpName}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            {item?.adminConfirmYn === "N" ? (
                                                                <span className={`cell-tag text-error`}>배정필요</span>
                                                            ) : (
                                                                <>-</>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            {(() => {
                                                                const status = contractStatusOptions.find(
                                                                    (e) => e.value === item?.contractStatus
                                                                );
                                                                return (
                                                                    <span
                                                                        className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label ?? "-"}
                                                                        </span>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            {(() => {
                                                                const status = chargeStatusOptions.find(
                                                                    (e) => e.value === item?.chargeStatus
                                                                );
                                                                return (
                                                                    <span
                                                                        className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label ?? "-"}
                                                                        </span>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            {(() => {
                                                                const status = orderSubStatusOption.find(
                                                                    (e) => e.value === item?.orderSubStatus
                                                                );
                                                                return (
                                                                    <span
                                                                        className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label ?? "-"}
                                                                        </span>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                                <span
                                                                    className="btn-cell btn-outline"
                                                                    onClick={() => {
                                                                        navigate(`/erp/order/detail/${item.id}`);
                                                                    }}
                                                                >
                                                                    상세보기
                                                                </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                {currentTab === "allocation" && (
                                    <table>
                                        <colgroup>
                                            <col width="8%"/>
                                            <col width="10%"/>
                                            <col width="10%"/>
                                            <col width="30%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">구분</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">요청일자</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">지역</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">차량정보</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">고객연령</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">보험사</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">공업사</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">상태</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">관리</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-tag tag-box tag-green">보험대차</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">2025.01.25(토) 10:10</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">경기 하남시</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="left">
                                                        <span className="cell-desc">(국산)K8 GL3 하이브리드 노블레스 (1,598cc)</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">만 26세 이상</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">삼성</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">블루핸즈</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-tag text-error">요청중</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span
                                                            className="btn-cell btn-outline"
                                                            onClick={() => {
                                                                setFormData((prevState) => ({
                                                                    ...prevState,
                                                                    orderDetailPopupStatus: true,
                                                                }));
                                                            }}
                                                        >
                                                            상세보기
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        {listData?.data?.length ? <Pagination pagination={listData?.pagination} setFormData={setFormData} /> : null}
                    </div>
                </div>
            </div>

            {orderDetailPopupStatus && (
                <OrderDetailPopup
                    popupStatus={orderDetailPopupStatus}
                    layer={false}
                    onClose={() => setFormData((prev) => ({ ...prev, orderDetailPopupStatus: false }))}
                    viewData={formData.selectedOrder}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    showConfirm={showConfirm}
                />
            )}

            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {partnersPopupStatus && (
                <PartnersPopup
                    layer={true}
                    onClose={async (value) => {
                        setFormData((prev) => ({
                            ...prev,
                            partnersPopupStatus: false,
                        }));

                        value.id &&
                            showConfirm(`배정받기`, "해당 렌트카업체로 배정을 받습니다.", [
                                {
                                    label: "예",
                                    className: "btn-primary",
                                    onClick: async () => {
                                        const body = {
                                            orderId: orderId,
                                            rentCorpId: value.id,
                                        };

                                        const res = await putConfirmOrder(body);

                                        if (res.error) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                toastMsg: res.error.message,
                                                partnersPopupStatus: false,
                                            }));
                                        }

                                        if (res.data) {
                                            res.data &&
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    toastMsg: "배정되었습니다.",
                                                    partnersPopupStatus: false,
                                                }));
                                            res.data &&
                                                setTimeout(() => {
                                                    navigate(`/order/detail/${orderId}`);
                                                }, 200);
                                        }
                                    },
                                },
                                {
                                    label: "아니오",
                                    className: "btn-cancel",
                                    onClick: () =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            confirmStatus: { confirmPopupStatus: false },
                                        })),
                                },
                            ]);
                    }}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const [filterOption, setFilterOption] = useState([]);
    const [clientLabel, setClientLabel] = useState({});
    const [statusLabel, setStatusLabel] = useState({});

    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;

        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    startedAt: start ? dateFormatToISOString(start, "start") : "",
                    endedAt: end ? dateFormatToISOString(end, "end") : "",
                },
            }));
        }

        if (type === "service") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    reserveDateStart: start ? dateFormatToISOString(start, "start") : "",
                    reserveDateEnd: end ? dateFormatToISOString(end, "end") : "",
                },
            }));
        }

        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);

        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                startedAt: dateFormatToISOString(start, "start"),
                endedAt: dateFormatToISOString(now, "end"),
            },
        }));

        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="오더번호 입력.."
                                name="serial_number"
                                value={parameters.serial_number}
                                onChange={handleParameterChange}
                            />
                        </div>

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="별칭 입력.."
                                name="alias"
                                value={parameters.alias}
                                onChange={handleParameterChange}
                            />
                        </div>

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="업체명 입력.."
                                name="rent_corp_name"
                                value={parameters.rent_corp_name}
                                onChange={handleParameterChange}
                            />
                        </div>

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="오더자 로그인아이디.."
                                name="order_login_id"
                                value={parameters.order_login_id}
                                onChange={handleParameterChange}
                            />
                        </div>

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="오더자 이름.."
                                name="order_member_name"
                                value={parameters.order_member_name}
                                onChange={handleParameterChange}
                            />
                        </div>


                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="사고차량번호"
                                name="accident_car_number"
                                value={parameters.accident_car_number}
                                onChange={handleParameterChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">

                        <div className="item-input" style={{width: "150px"}}>
                            <input
                                type="text"
                                placeholder="보험사명 입력.."
                                name="insurance_corp_name"
                                value={parameters.insurance_corp_name}
                                onChange={handleParameterChange}
                            />
                        </div>

                        <div className="item-select">
                            <Select
                                options={orderSubStatusOption}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="오더상태"
                                value={orderSubStatusOption.find((e) => e.value === formData.parameters.order_sub_status_in) || ""}
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {...prev.parameters, order_sub_status_in: option.value},
                                    }));
                                }}
                            />
                        </div>

                        <div className="item-select">
                            <Select
                                options={rolesOptions}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="회원유형"
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {...prev.parameters, order_member_roles_in: option.value},
                                    }));
                                }}
                            />
                        </div>

                        <div className="item-input" style={{width: "300px"}}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ...pageFilter,
                                    }));
                                    setClientLabel({value: null, label: "전체"});
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const OrderDetailPopup = ({popupStatus, layer = true, onClose, viewData, setFormData, showConfirm}) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    const [putConfirmOrder] = usePutConfirmOrderAdminMutation();

    const [item, setItem] = useState({
        id: "",
        serialNumber: "",
        orderType: "",
        orderStatus: "",
        orderSubStatus: "",
        createdAt: "",
        age: "",
        location1: "",
        location2: "",
        carInfo: "",
        customerPhone: "",
        insuranceCorpName: "",
        insReceiptNumber: "",
        expectFault: "",
        chargeMethod: "",
        chargeRate: "",
        chargeMemo: "",
    });

    useEffect(() => {
        viewData &&
        setItem({
            id: viewData.id,
            serialNumber: viewData.serialNumber,
            orderType: orderTypeOptions.find((e) => e.value === viewData.orderType)?.label,
            orderStatus: viewData.orderStatus,
            orderSubStatus: viewData.orderSubStatus,
            createdAt: dateFormatDateTime(viewData?.createdAt),
            age: calculateAge(new Date(viewData?.orderCustomer?.birthDate) ?? new Date()),
            location1: viewData.orderCustomer?.location2AddressCode?.address1 ?? "",
            location2: viewData.orderCustomer?.location2AddressCode?.address2 ?? "",
            carInfo: `${viewData.modelName ?? ""} ${viewData.modelDetailName ?? ""} ${viewData.trimName ?? ""} ${
                viewData.className ?? ""
            }`,
            customerPhone: viewData.orderCustomer?.phone,
            insuranceCorpName: viewData.orderInsurance?.insuranceCorpName,
            insReceiptNumber: viewData.orderInsurance?.receiptNumber,
            expectFault: viewData.orderInsurance?.expectFault,
            chargeMethod: chargeMethodOptions.find((e) => e.value === viewData.orderInsurance?.chargeMethod)?.label,
            chargeRate: viewData.orderInsurance?.chargeRate,
            chargeMemo: viewData.orderInsurance?.memo,
        });
    }, [viewData]);

    useEffect(() => {
        if (popupStatus) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [popupStatus]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 200);
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleConfirm = async () => {
        showConfirm(`배정받기`, "배정을 받습니다.", [
            {
                label: "예",
                className: "btn-primary",
                onClick: async () => {
                    const body = {
                        orderId: item.id,
                    };

                    const res = await putConfirmOrder(body);

                    if (res.error) {
                        setFormData((prev) => ({
                            ...prev,
                            toastMsg: res.error.message,
                            partnersPopupStatus: false,
                        }));
                    }

                    if (res.data) {
                        res.data &&
                        setFormData((prev) => ({
                            ...prev,
                            toastMsg: "배정되었습니다.",
                            partnersPopupStatus: false,
                        }));
                        res.data &&
                        setTimeout(() => {
                            navigate(`/order/detail/${item.id}`);
                        }, 200);
                    }
                },
            },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: {confirmPopupStatus: false},
                    })),
            },
        ]);
    };

    const maskValue = (value, prefixLength) => {
        if (!value) return "";
        if (value.length <= prefixLength) return value;
        return value.substring(0, prefixLength) + "*".repeat(value.length - prefixLength);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={handleClose}></div>

            <div className={`popup popup-side order-detail-popup ${isVisible ? "active" : ""}`}>
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">오더 목록 상세</span>
                    </div>
                    <div className="btn-close" onClick={handleClose}></div>
                </div>
                <div className="popup-content">
                    <div className="order-detail-info">
                        <div className="info-content">
                            <div className="detail-summary">
                                <div className="summary-info">
                                    <span className="insurance-type">{item.orderType}</span>
                                    <span className="insurance-num">{item.serialNumber}</span>
                                </div>
                                <div className="order-status">
                                    {orderSubStatusOption.find((e) => e.value === item?.orderSubStatus)?.label}
                                </div>
                            </div>
                            <div className="detail-info">
                                <div className="info-item">
                                    <div className="item-desc">
                                        {`${item.location1} ${item.location2}`} / {item.age}{" "}
                                    </div>
                                    <div className="item-date">{item.createdAt}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="side_item-container">
                        <div className="side_item-wrapper">
                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">오더 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">요청구분</span>
                                        <span className="item-desc">{item.orderType}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">차량정보</span>
                                        <span className="item-desc">{item.carInfo}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">이용지역</span>
                                        <span className="item-desc">
                                            {item.location1} {item.location2}
                                        </span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">연락처(고객)</span>
                                        <span className="item-desc">{maskValue(item.customerPhone, 3)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">보험 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">보험사</span>
                                        <span className="item-desc">{item.insuranceCorpName}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">접수번호</span>
                                        <span className="item-desc">{maskValue(item.insReceiptNumber, 4)}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">예상과실</span>
                                        <span className="item-desc">{item.expectFault}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">청구 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">청구방식</span>
                                        <span className="item-desc">{item.chargeMethod}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">청구율</span>
                                        <span className="item-desc">{item.chargeRate}%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">요청사항</span>
                                        <span className="item-desc">{item.chargeMemo}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel" onClick={handleClose}>
                        닫기
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};

const PartnersPopup = ({ layer = true, onClose, formData, setFormData }) => {
    const [query, setQuery] = useState("");
    const { data: searchData, isLoading: isLoadingSearchRentCorp, refetch } = useGetMyRentCorpQuery();

    useEffect(() => {
        refetch();
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    useEffect(() => {
        console.log(searchData);
    }, [searchData]);

    const handleRegister = () => {
        onClose();
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup service-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">사업자 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="입력하세요."
                                                name="query"
                                                onChange={(e) => setQuery(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"32%"} />
                                            <col width={"17%"} />
                                            <col width={"17%"} />
                                            <col width={"22%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">사업자명</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">대표자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">지역</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {searchData && searchData?.data?.length === 0 ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="12" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            searchData?.data?.map((item, index) => (
                                                <tbody>
                                                    <tr
                                                        key={`searchResult${index}`}
                                                        onClick={(e) => {
                                                            onClose(item);
                                                        }}
                                                    >
                                                        <td>
                                                            <div className="cell">
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox">
                                                                        <input type="checkbox" id="checkAll" name="checkAll" />
                                                                        <label htmlFor=""></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.corpName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.repName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.address}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.corpNumber}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ))
                                        )}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel">취소</button>
                    <button className="btn btn-primary btn-confirm">완료</button>
                </div>
            </div>
        </>,
        document.body
    );
};
